// Вид варианта ответа в прохождении. Палитра — та же, что у `QuizOptionCard`
// из @teach/ui (`quizOptionStyle` — порт плеерного `blockPalette.optionStyle`),
// чтобы чипы `fill_blank`, слот пропуска и карточки сопоставления не разъехались
// с карточками квиза. Толщину рамки задаёт класс потребителя, как в плеере.
import type { CSSProperties } from 'react'
import { quizOptionStyle, type QuizOptionState } from '@teach/ui'
import type { Verdict } from '../../preview/verdict'
import { verdictGrade } from '../../preview/verdictView'

/** После проверки правильный вариант зеленеет, даже если его не выбрали, а
 *  выбранный неправильный краснеет — так показывает результат плеер. */
export const optionState = (
  selected: boolean,
  isCorrect: boolean,
  verdict: Verdict | null,
): QuizOptionState => {
  // Оценки нет — красить варианты не во что.
  if (verdictGrade(verdict) === 'ungraded') return selected ? 'selected' : 'idle'
  if (isCorrect) return 'correct'
  return selected ? 'incorrect' : 'idle'
}

/** Вердикт как состояние одного поля/карточки (у опроса и сопоставления
 *  выбранности нет — красится сам вердикт). */
export const verdictState = (verdict: Verdict | null): QuizOptionState => {
  const grade = verdictGrade(verdict)
  return grade === 'ungraded' ? 'idle' : grade
}

export const optionCardStyle = quizOptionStyle

/**
 * Тени пилюль «пропуска» (чипы и заполненный слот) — как в мобилке
 * (quiz-block/styles.ts, FILL_SHADOW): снаружи 0 3 1.5, у выбранной — та же
 * внутренняя, что у вариантов квиза.
 */
const FILL_SHADOW: Record<Exclude<QuizOptionState, 'selected'>, string> = {
  idle: '0 3px 1.5px rgba(0, 0, 0, 0.12)',
  correct: '0 3px 1.5px #97c3a8',
  incorrect: '0 3px 1.5px #c79999',
}

/** Стиль пилюли «пропуска»: палитра варианта квиза + тень из мобилки. */
export const fillPillStyle = (state: QuizOptionState): CSSProperties => {
  const style = optionCardStyle(state)
  return state === 'selected' ? style : { ...style, boxShadow: FILL_SHADOW[state] }
}
